import { FC } from 'react'

import { Body, Label, List, ListItem } from './styles'

export const DesktopFilterBarSkeleton: FC = () => {
  return (
    <Body>
      <List>
        <ListItem>
          <Label />
        </ListItem>
        <ListItem>
          <Label />
        </ListItem>
        <ListItem>
          <Label />
        </ListItem>
        <ListItem>
          <Label />
        </ListItem>
      </List>
    </Body>
  )
}
